'use client';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Checkbox,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerHeader,
   DrawerOverlay,
   Flex,
   Input,
   InputGroup,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Tr,
   useColorMode,
   useColorModeValue,
   useDisclosure,
} from '@chakra-ui/react';
import Select from 'react-select';
import Card from 'components/card/Card';
import { GridItem } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Grid } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import ViewSingleCashBankData from 'components/UIcomponents/ViewSingleCashBankData';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById } from '../../../../redux/actions/account';
import StatementFilter from '../components/StatementFilter';
import { IoFilterOutline } from 'react-icons/io5';
import {
   deletePurchaseReturnInvoice,
   getSinglePurchaseReturn,
   getSinglePurchaseReturnWithPrevAndNext,
} from '../../../../redux/actions/purchaseReturnInvoice';
import {
   deleteSaleReturnInvoice,
   getSingleSalesReturnWithPrevAndNext,
} from '../../../../redux/actions/salesReturnInvoice';
import { deleteRecord } from 'utils/util';
import { getOneVoucher } from '../../../../redux/actions/voucher';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { clearCacheReport, getReportLedger, statementCheckedStyle } from '../../../../redux/actions/reports';
import { getAccountForReport } from '../../../../redux/actions/account';
import { useGlobal, useUser } from '../../../../contexts';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { LuRefreshCcw } from 'react-icons/lu';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { motion } from 'framer-motion';
import * as XLSX from 'xlsx-js-style';
import 'jspdf-autotable';
import JournalVoucherForm from 'views/admin/journal-vouchers/Pages/JournalVoucherForm';
import { getJournalVoucher } from '../../../../redux/actions/journalVoucher';
import { jsPDF } from 'jspdf';
import PaymentcaseFormEdit from '../../cash/PaymentcaseFormEdit';
import * as Yup from 'yup';
import { getDaybookForPayments } from '../../../../redux/actions/daybook';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';
import DeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/DeletePasswordModal';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

// OPTIMIZED: Memoized row component to prevent unnecessary re-renders
const MemoizedDataRow = React.memo(
   ({
      row,
      idx,
      accountId,
      rowId,
      isSelected,
      onSelection,
      onRowClick,
      formatDateToDDMMYYYY,
      iconColor,
      selectedRows,
      formatCellAmount,
      localStyleUpdates,
   }) => {
      const isOddRow = idx % 2 !== 0;
      const absBal = Math.abs(row.bal);
      const formattedVal = absBal.toLocaleString('en-IN', {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });
      const [intPart, decimalPart] = formattedVal.split('.');

      const localStyleKey = `${row.DocType}-${row.docid}`;
      const effectiveCheckedStyle =
         localStyleUpdates[localStyleKey] !== undefined ? localStyleUpdates[localStyleKey] : row.checkedStyle;

      const getRowColors = () => {
         if (effectiveCheckedStyle === 1) {
            return {
               bg: 'rgba(16, 185, 129, 0.12)',
               hoverBg: 'rgba(16, 185, 129, 0.18)',
               textColor: 'green.600',
               borderColor: 'green.500',
            };
         } else if (effectiveCheckedStyle === 2) {
            return {
               bg: 'rgba(239, 68, 68, 0.12)',
               hoverBg: 'rgba(239, 68, 68, 0.18)',
               textColor: 'red.600',
               borderColor: 'red.500',
            };
         } else {
            return {
               bg: isOddRow ? 'rgba(0, 63, 140, 0.05)' : 'transparent',
               hoverBg: 'rgba(0, 63, 140, 0.08)',
               textColor: iconColor,
               borderColor: 'blue.400',
            };
         }
      };

      const rowColors = getRowColors();

      return (
         <Tr
            color={rowColors.textColor}
            px={3}
            py={2}
            key={`row-${rowId}`}
            onClick={(e) => onRowClick(row, e)}
            cursor="pointer"
            _hover={{ bg: rowColors.hoverBg }}
            bg={rowColors.bg}
            borderLeft="4px solid"
            borderLeftColor={rowColors.borderColor}>
            <Td fontSize={{ base: '12px', md: '13px' }} py={1} width="50px" onClick={(e) => e.stopPropagation()}>
               <Checkbox
                  isChecked={isSelected}
                  onChange={(e) => {
                     e.stopPropagation();
                     onSelection(rowId, e.target.checked, row);
                     console.log('rowId', rowId);
                  }}
                  colorScheme="blue"
                  size="md"
               />
            </Td>
            <Td fontSize={{ base: '12px', md: '13px' }} py={0} width="110px">
               {row.date ? formatDateToDDMMYYYY(row.date) : '-'}
            </Td>
            <Td fontSize={{ base: '12px', md: '13px' }} py={0} width="80px">
               {row.docnumber || '-'}
            </Td>
            <Td fontSize={{ base: '12px', md: '13px' }} py={0} width="180px">
               {row.daybookname || '-'}
            </Td>
            <Td fontSize={{ base: '12px', md: '13px' }} py={0} width="180px">
               {row.finalcontraaccountname || '-'}
            </Td>
            <Td
               fontSize={{ base: '12px', md: '13px' }}
               py={0}
               maxW={{ base: '120px', md: '200px' }}
               overflow="hidden"
               textOverflow="ellipsis"
               whiteSpace={{ base: 'normal', lg: 'nowrap' }}>
               {row.particulars || '-'}
            </Td>
            <Td fontSize={{ base: '12px', md: '13px' }} py={0} isNumeric width="120px">
               {row.txnType === 1 ? formatCellAmount(row.amount) : '-'}
            </Td>

            <Td fontSize={{ base: '12px', md: '13px' }} py={0} isNumeric width="120px">
               {row.txnType === 0 ? formatCellAmount(row.amount) : '-'}
            </Td>

            <Td fontSize={{ base: '12px', md: '13px' }} py={0} isNumeric width="140px">
               {row.bal === undefined || row.bal === null ? (
                  '-'
               ) : (
                  <Box display="flex" justifyContent="flex-end" gap="1px" whiteSpace="nowrap">
                     <Text>{intPart}</Text>
                     <Text fontSize={{ base: '9px', md: '10px' }} mt={0.5}>
                        .{decimalPart}
                     </Text>
                     <Text fontSize={{ base: '10px', md: '11px' }}>
                        {'\u00A0'}
                        {row.bal < 0 ? 'DB' : 'CR'}
                     </Text>
                  </Box>
               )}
            </Td>
         </Tr>
      );
   },
   (prevProps, nextProps) => {
      // Custom comparison - only re-render if these change
      return (
         prevProps.isSelected === nextProps.isSelected &&
         prevProps.row.checkedStyle === nextProps.row.checkedStyle &&
         prevProps.row.bal === nextProps.row.bal
      );
   },
);

const Ledger = () => {
   // Constants
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const iconColor = useColorModeValue('#000000', '#ffffff');
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   // Context and Redux
   const { companyList, userGlobalSettingsData } = useGlobal();
   const accounts = useSelector((state) => state.account.listForReport || []);
   const rawLedger = useSelector((state) => state.reports.ledger || []);
   const dispatch = useDispatch();
   const { user } = useUser();
   const dbName = localStorage.getItem('dbName');

   // Refs
   const abortControllerRef = useRef(null);
   const searchTimeoutRef = useRef(null);
   const wrapperRef = useRef();
   const initialLoadRef = useRef(false);
   const previousParamsRef = useRef({});

   // OPTIMIZED: Use Map for faster lookups
   const [localStyleUpdates, setLocalStyleUpdates] = useState({});
   const [selectedRows, setSelectedRows] = useState({});
   const [selectedRowData, setSelectedRowData] = useState([]);
   const [isAllSelected, setIsAllSelected] = useState(false);
   const [activeFilter, setActiveFilter] = useState('all');
   const [entityType, setEntityType] = useState([]);
   const [entityTypesv, setEntityTypesv] = useState([]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isBankPageTrue, setIsBankPageTrue] = React.useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [isOpenSingleViewcnb, setIsOpenSingleViewcnb] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isModalLoading, setIsModalLoading] = useState(false);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();

   const singleEntity = useSelector((state) => {
      if (entityType === 'receivemaster') {
         return state?.receiveInventory?.single || {};
      } else if (entityType === 'issuemaster') {
         return state?.issueInventory?.single || {};
      } else if (entityType === 'cash') {
         return state.voucher?.single || {};
      } else if (entityType === 'bank') {
         return state.voucher?.single || {};
      } else {
         return {};
      }
   });

   const validationSchema = Yup.object().shape({
      daybookId: Yup.number().required('Daybook is required'),
      accountId: Yup.number()
         .typeError('Account must be a valid')
         .required('Account is required')
         .min(1, 'Account must be greater than 0'),
      amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),
      docNumber: Yup.string().required('Document number is required'),
      txnDate: Yup.date().required('Transaction date is required').typeError('Invalid transaction date'),
      txnType: Yup.number().required('Transaction type is required'),
   });

   const accountData = useSelector((state) => state.account.list);
   const shouldSendIdInDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const daybookTypeData = useSelector((state) => state.daybook?.listPayment || null);
   const [transactionType, setTransactionType] = useState('payment');
   const [receivedAmount, setReceivedAmount] = useState(0);
   const [totalPendingAccount, setTotalPendingAccount] = useState(0);
   const [updateFormLoading, setUpdateFormLoading] = useState(false);
   const [isOutstandingModalOpen, setIsOutstandingModalOpen] = useState(false);
   const [selectedEditAccount, setSelectedEditAccount] = useState(null);
   const [pendingVoucher, setPendingVoucher] = useState([]);
   const [errors, setErrors] = useState({});
   const [sorting, setSorting] = useState([]);
   const [dataId, setDataId] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const daybookData = useSelector((state) => state.daybook?.list || []);

   const [formData, setFormData] = useState({
      companyId: parseInt(localStorage.getItem('companyId')),
      daybookId: null,
      docNumber: 0,
      txnType: `${transactionType === 'payment' ? 1 : 0}`,
      txnDate: new Date().toISOString().split('T')[0],
      accountId: null,
      amount: receivedAmount ? receivedAmount : 0,
      brokerId: null,
      supplierId: null,
      chequeNo: 0,
      transactionNo: null,
      bankId: null,
      bankBranchId: null,
      particulars: '',
      depositeDate: null,
      clearingDate: null,
      tdsApplicable: false,
      tdsAccountId: null,
      tdsLimit: 0,
      tdsRate: 0,
      tdsCess: 0,
      tdsSurcharge: 0,
      tdsAmount: 0,
      tdsCessAmount: 0,
      tdsSurchargeAmount: 0,
      tdsHCessAmount: 0,
      tdsInterestAmount: 0,
      tdsPenaltyAmount: 0,
      tdsOthersAmount: 0,
      notes1: '',
      notes2: '',
      notes3: '',
      notes4: '',
      notes5: '',
      userNote: '',
      taxableValue: '',
      GSTAmount: 0,
      stateOfSupply: 0,
      isRCM: false,
      GSTSubTxnType: 0,
      HSNSACId: null,
      typeofSupply: 0,
      partyBillNo: 0,
      GSTTxnType: 0,
      chequeDate: new Date().toISOString().split('T')[0],
      outAdjustments: [],
   });

   const [currentRow, setCurrentRow] = useState(null);
   const [isEditMode, setIsEditMode] = useState(true);
   const [isOpenJV, setisOpenJV] = React.useState(null);

   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdown = globalSetting || false;
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;

   const cashReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cashReceive
      : null;
   const cashPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.cashPayment
      : null;
   const bankReceiveRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankReceive
      : null;
   const bankPaymentRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.bankPayment
      : null;

   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;

   const account = useSelector((state) => state.account.single);
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);

   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityType === 'purchasereturn'
            ? viewDatapr?.data[0]
            : entityType === 'salereturn'
            ? viewDatasr?.data[0]
            : entityType === 'saleinvoice'
            ? viewDatasi
            : entityType === 'purchaseinvoice'
            ? viewDatapi
            : null;

      const pagination =
         entityType === 'purchasereturn'
            ? viewDatapr?.pagination
            : entityType === 'salereturn'
            ? viewDatasr?.pagination
            : entityType === 'saleinvoice'
            ? viewDatasi?.pagination
            : entityType === 'purchaseinvoice'
            ? viewDatapi?.pagination
            : null;

      return { viewDetail: data, paginate: pagination };
   }, [
      entityType,
      viewDatapr?.data,
      viewDatapr?.pagination,
      viewDatasr?.data,
      viewDatasr?.pagination,
      viewDatasi,
      viewDatapi,
   ]);

   // State
   const [companyFilter, setCompanyFilter] = useState([]);
   const [searchInput, setSearchInput] = useState('');
   const [searchQuery, setSearchQuery] = useState('');
   const [accountId, setAccountId] = useState(null);
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);
      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0],
         toDate: today.toISOString().split('T')[0],
      };
   });

   const [isLoading, setIsLoading] = useState(false);
   const [expanded, setExpanded] = useState(false);
   const [expandedItems, setExpandedItems] = useState({});
   const { isOpen, onOpen, onClose } = useDisclosure();

   // Initialize expanded state
   useEffect(() => {
      if (rawLedger && rawLedger.length > 0) {
         const initialExpandedState = {};
         rawLedger.forEach((company) => {
            initialExpandedState[`company-${company.companyId}`] = true;
            if (company.accounts && company.accounts.length > 0) {
               company.accounts.forEach((account) => {
                  initialExpandedState[`account-${account.accountId}`] = true;
               });
            }
         });
         setExpandedItems(initialExpandedState);
      }
   }, [rawLedger]);

   useEffect(() => {
      if (accountId !== null) {
         localStorage.setItem('ledgerSelectedAccountId', accountId.toString());
      } else {
         localStorage.removeItem('ledgerSelectedAccountId');
      }
   }, [accountId]);

   const formatCellAmount = (amount) => {
      const formatted = Math.abs(amount).toLocaleString('en-IN', {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });
      const [integerPart, decimalPart] = formatted.split('.');

      return (
         <>
            {integerPart}
            <Text as="span" fontSize={{ base: '9px', md: '10px' }}>
               .{decimalPart}
            </Text>
         </>
      );
   };

   // Memoized values
   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const accountOptions = useMemo(() => {
      return accounts.map((account) => ({
         ...account,
         value: account.id,
         label: account.name,
      }));
   }, [accounts]);

   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [],
      [companyFilter],
   );

   // Process ledger data
   const processedLedger = useMemo(() => {
      return rawLedger.map((company) => ({
         ...company,
         accounts: company.accounts
            ? Object.keys(company.accounts).map((accountId) => {
                 const account = company.accounts[accountId];
                 return {
                    ...account,
                    data: Array.isArray(account.data) ? account.data.slice().reverse() : [],
                 };
              })
            : [],
      }));
   }, [rawLedger]);

   // OPTIMIZED: Get all rows from processed ledger
   const getAllRows = useCallback(() => {
      const allRows = [];
      processedLedger.forEach((company) => {
         company.accounts?.forEach((account) => {
            account.data?.forEach((row, idx) => {
               const rowId = `${account.accountId}-${idx}`;
               allRows.push({ rowId, row, accountId: account.accountId });
            });
         });
      });
      return allRows;
   }, [processedLedger]);

   // OPTIMIZED: Filter rows based on checkedStyle
   const getFilteredRows = useCallback(
      (mode) => {
         const allRows = getAllRows();
         switch (mode) {
            case 'checked':
               return allRows.filter(({ row }) => row.checkedStyle === 1);
            case 'problem':
               return allRows.filter(({ row }) => row.checkedStyle === 2);
            case 'unchecked':
               return allRows.filter(({ row }) => row.checkedStyle === 0 || !row.checkedStyle);
            case 'all':
            default:
               return allRows;
         }
      },
      [getAllRows],
   );

   // OPTIMIZED: Get counts for different statuses
   const getStatusCounts = useCallback(() => {
      const allRows = getAllRows();
      return {
         all: allRows.length,
         checked: allRows.filter(({ row }) => row.checkedStyle === 1).length,
         problem: allRows.filter(({ row }) => row.checkedStyle === 2).length,
         unchecked: allRows.filter(({ row }) => row.checkedStyle === 0 || !row.checkedStyle).length,
      };
   }, [getAllRows]);

   const statusCounts = getStatusCounts();

   // Data fetching
   const fetchData = useCallback(
      async (searchQuery = '') => {
         // Check if we have valid parameters
         const hasValidCompanyIds =
            Array.isArray(companyIds) &&
            companyIds.length > 0 &&
            !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
         const hasValidAccountId = accountId && !isNaN(Number(accountId)) && Number(accountId) > 0;
         const hasValidDateRange = dateRange.fromDate && dateRange.toDate;

         if (!hasValidCompanyIds || !hasValidAccountId || !hasValidDateRange) {
            return;
         }

         // OPTIMIZED: Check if parameters have actually changed
         const currentParams = {
            companyIds: companyIds.join(','),
            accountId,
            fromDate: dateRange.fromDate,
            toDate: dateRange.toDate,
            searchQuery,
         };

         const previousParams = previousParamsRef.current;

         // If parameters haven't changed and we've already loaded data, skip the API call
         if (
            initialLoadRef.current &&
            previousParams.companyIds === currentParams.companyIds &&
            previousParams.accountId === currentParams.accountId &&
            previousParams.fromDate === currentParams.fromDate &&
            previousParams.toDate === currentParams.toDate &&
            previousParams.searchQuery === currentParams.searchQuery
         ) {
            return;
         }

         if (abortControllerRef.current) {
            abortControllerRef.current.abort();
         }

         abortControllerRef.current = new AbortController();
         setIsLoading(true);

         try {
            const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

            await dispatch(
               getReportLedger({
                  fromDate: dateRange.fromDate,
                  toDate: dateRange.toDate,
                  companyIds: validCompanyIds.join(','),
                  accIds: accountId,
                  orderBy: 'desc',
                  search: searchQuery,
               }),
            );

            // OPTIMIZED: Update previous params after successful call
            previousParamsRef.current = currentParams;
            initialLoadRef.current = true;
         } catch (error) {
            if (error.name !== 'AbortError') {
               console.error('Error fetching ledger:', error);
            }
         } finally {
            setIsLoading(false);
            abortControllerRef.current = null;
         }
      },
      [dispatch, companyIds, accountId, dateRange],
   );

   useEffect(() => {
      const hasValidCompanyIds =
         Array.isArray(companyIds) &&
         companyIds.length > 0 &&
         !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
      const hasValidAccountId = accountId && !isNaN(Number(accountId)) && Number(accountId) > 0;
      const hasValidDateRange = dateRange.fromDate && dateRange.toDate;

      if (hasValidCompanyIds && hasValidAccountId && hasValidDateRange) {
         // Use setTimeout to avoid immediate call on mount
         const timer = setTimeout(() => {
            fetchData('');
         }, 100);

         return () => clearTimeout(timer);
      }
   }, [companyIds, accountId, dateRange.fromDate, dateRange.toDate, fetchData]);
   const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

   useEffect(() => {
      const hasValidCompanyIds =
         Array.isArray(companyIds) &&
         companyIds.length > 0 &&
         !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);

      if (!hasValidCompanyIds) {
         return;
      }

      const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

      dispatch(clearCacheReport());
      dispatch(
         getAccountForReport({
            compId: user?.loginhistory?.companyId,
            status: true,
            ...(shouldShowCompanyDropdown && {
               companyIds: validCompanyIds.join(','),
            }),
         }),
      );
   }, [dispatch, user, companyIds, shouldShowCompanyDropdown]);

   useEffect(() => {
      const timer = setTimeout(() => {
         fetchData();
      }, 500);

      return () => {
         clearTimeout(timer);
         if (abortControllerRef.current) {
            abortControllerRef.current.abort();
         }
      };
   }, [fetchData]);

   const storedCompanyId = localStorage.getItem('companyId');
   useEffect(() => {
      if (storedCompanyId && companyList?.length > 0 && !initialLoadRef.current) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList?.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList, storedCompanyId]);

   // Event handlers
   const handleDateRangeChange = useCallback(
      (dates) => {
         if (!dates || dates.length !== 2) return;

         const [from, to] = dates.map((date) => {
            if (!date) return '';
            const d = new Date(date);
            if (isNaN(d.getTime())) return '';
            return d.toISOString().split('T')[0];
         });

         setDateRange({
            fromDate: from || dateRange.fromDate,
            toDate: to || dateRange.toDate,
         });
      },
      [dateRange],
   );

   const handleCompanyChange = useCallback((selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   }, []);

   const handleAccountChange = useCallback((selectedOption) => {
      const newAccountId = selectedOption ? selectedOption.value : null;
      setAccountId(newAccountId);
   }, []);

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.altKey) {
            e.preventDefault();
            e.stopPropagation();
         }
      };

      document.addEventListener('keydown', handleKeyDown, { capture: true });
      return () => document.removeEventListener('keydown', handleKeyDown, { capture: true });
   }, []);

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchInput(value);

      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }

      searchTimeoutRef.current = setTimeout(() => {
         setSearchQuery(value);
      }, 600);
   };

   useEffect(() => {
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }

      // Only search if we have initial data loaded
      if (initialLoadRef.current) {
         searchTimeoutRef.current = setTimeout(() => {
            fetchData(searchQuery);
         }, 600);
      }

      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
      };
   }, [searchQuery, fetchData]);

   const handleRefresh = useCallback(() => {
      initialLoadRef.current = false;
      previousParamsRef.current = {};
      fetchData(searchQuery);
   }, [fetchData, searchQuery]);

   const toggleExpand = useCallback((id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   }, []);

   // OPTIMIZED: Formatting function
   const formatDateToDDMMYYYY = useCallback((dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
   }, []);

   // OPTIMIZED: Fast row selection handler
   const handleRowSelection = useCallback((rowId, isChecked, row) => {
      setSelectedRows((prev) => {
         const newRows = { ...prev };
         if (isChecked) {
            newRows[rowId] = true;
         } else {
            delete newRows[rowId];
         }
         return newRows;
      });

      setSelectedRowData((prev) => {
         if (isChecked) {
            if (!prev.find((item) => item.rowId === rowId)) {
               return [...prev, { rowId, ...row }];
            }
            return prev;
         } else {
            return prev.filter((item) => item.rowId !== rowId);
         }
      });
   }, []);

   // OPTIMIZED: Fast select all in account
   const handleSelectAllAccount = useCallback((accountId, accountData, isChecked) => {
      setSelectedRows((prev) => {
         const newRows = { ...prev };
         accountData.data.forEach((row, idx) => {
            const rowId = `${accountId}-${idx}`;
            if (isChecked) {
               newRows[rowId] = true;
            } else {
               delete newRows[rowId];
            }
         });
         return newRows;
      });

      setSelectedRowData((prev) => {
         if (isChecked) {
            const newRows = accountData.data.map((row, idx) => ({
               rowId: `${accountId}-${idx}`,
               ...row,
            }));
            const existingIds = new Set(prev.map((item) => item.rowId));
            const uniqueNewRows = newRows.filter((row) => !existingIds.has(row.rowId));
            return [...prev, ...uniqueNewRows];
         } else {
            return prev.filter((item) => !item.rowId.startsWith(`${accountId}-`));
         }
      });
   }, []);

   // OPTIMIZED: Quick filter selections
   const handleSelectAll = useCallback(() => {
      if (statusCounts.all === 0) return;
      setActiveFilter('all');
      const allRows = getAllRows();
      const newRows = {};
      allRows.forEach(({ rowId }) => {
         newRows[rowId] = true;
      });
      setSelectedRows(newRows);
      setSelectedRowData(allRows.map(({ rowId, row }) => ({ rowId, ...row })));
      setIsAllSelected(true);
   }, [statusCounts.all, getAllRows]);

   const handleSelectChecked = useCallback(() => {
      if (statusCounts.checked === 0) return;
      setActiveFilter('checked');
      const checkedRows = getFilteredRows('checked');
      const newRows = {};
      checkedRows.forEach(({ rowId }) => {
         newRows[rowId] = true;
      });
      setSelectedRows(newRows);
      setSelectedRowData(checkedRows.map(({ rowId, row }) => ({ rowId, ...row })));
      setIsAllSelected(false);
   }, [statusCounts.checked, getFilteredRows]);

   const handleSelectProblem = useCallback(() => {
      if (statusCounts.problem === 0) return;
      setActiveFilter('problem');
      const problemRows = getFilteredRows('problem');
      const newRows = {};
      problemRows.forEach(({ rowId }) => {
         newRows[rowId] = true;
      });
      setSelectedRows(newRows);
      setSelectedRowData(problemRows.map(({ rowId, row }) => ({ rowId, ...row })));
      setIsAllSelected(false);
   }, [statusCounts.problem, getFilteredRows]);

   const handleSelectUnchecked = useCallback(() => {
      if (statusCounts.unchecked === 0) return;
      setActiveFilter('unchecked');
      const uncheckedRows = getFilteredRows('unchecked');
      const newRows = {};
      uncheckedRows.forEach(({ rowId }) => {
         newRows[rowId] = true;
      });
      setSelectedRows(newRows);
      setSelectedRowData(uncheckedRows.map(({ rowId, row }) => ({ rowId, ...row })));
      setIsAllSelected(false);
   }, [statusCounts.unchecked, getFilteredRows]);

   const handleMasterCheckboxChange = useCallback(
      (e) => {
         const checked = e.target.checked;
         setIsAllSelected(checked);

         if (checked) {
            const filteredRows = getFilteredRows(activeFilter);
            const newRows = {};
            filteredRows.forEach(({ rowId }) => {
               newRows[rowId] = true;
            });
            setSelectedRows(newRows);
            setSelectedRowData(filteredRows.map(({ rowId, row }) => ({ rowId, ...row })));
         } else {
            setSelectedRows({});
            setSelectedRowData([]);
         }
      },
      [getFilteredRows, activeFilter],
   );

   // OPTIMIZED: Filter account data
   const getFilteredAccountData = useCallback(
      (accountData) => {
         if (activeFilter === 'all') {
            return accountData;
         }

         const filteredData = accountData.data.filter((row) => {
            switch (activeFilter) {
               case 'checked':
                  return row.checkedStyle === 1;
               case 'problem':
                  return row.checkedStyle === 2;
               case 'unchecked':
                  return row.checkedStyle === 0 || !row.checkedStyle;
               default:
                  return true;
            }
         });

         return {
            ...accountData,
            data: filteredData,
         };
      },
      [activeFilter],
   );

   // OPTIMIZED: Batch API calls with refresh
   const handleUnchecked = useCallback(async () => {
      if (selectedRowData.length === 0) return;

      const uncheckedStyles = selectedRowData.map((row) => ({
         entryType: row.DocType,
         entryId: row.docid,
         type: 0,
      }));

      // Store selected rows for reference
      const currentSelectedRows = [...selectedRowData];

      // Clear selection immediately
      setSelectedRows({});
      setSelectedRowData([]);

      try {
         // Call API
         await dispatch(statementCheckedStyle({ checkedStyles: uncheckedStyles }));
         await dispatch(
            getReportLedger({
               fromDate: dateRange.fromDate,
               toDate: dateRange.toDate,
               companyIds: validCompanyIds.join(','),
               accIds: accountId,
               orderBy: 'desc',
               search: searchQuery,
            }),
         );

         // OPTIMIZED: Update local state with new checkedStyle values
         setLocalStyleUpdates((prev) => {
            const updated = { ...prev };
            currentSelectedRows.forEach((row) => {
               const key = `${row.DocType}-${row.docid}`;
               updated[key] = 0; // Set to unchecked
            });
            return updated;
         });

         // Refresh data after short delay to ensure state is updated
         setTimeout(() => {
            fetchData(searchQuery);
            // Clear local updates after data refresh
            setTimeout(() => {
               setLocalStyleUpdates((prev) => {
                  const updated = { ...prev };
                  currentSelectedRows.forEach((row) => {
                     const key = `${row.DocType}-${row.docid}`;
                     delete updated[key];
                  });
                  return updated;
               });
            }, 1000);
         }, 300);
      } catch (error) {
         console.error('Error:', error);
         fetchData(searchQuery);
      }
   }, [selectedRowData, dispatch, searchQuery, fetchData]);

   // Similarly update handleChecked and handleProblem
   const handleChecked = useCallback(async () => {
      if (selectedRowData.length === 0) return;

      const checkedStyles = selectedRowData.map((row) => ({
         entryType: row.DocType,
         entryId: row.docid,
         type: 1,
      }));

      const currentSelectedRows = [...selectedRowData];
      setSelectedRows({});
      setSelectedRowData([]);

      try {
         await dispatch(statementCheckedStyle({ checkedStyles }));
         await dispatch(
            getReportLedger({
               fromDate: dateRange.fromDate,
               toDate: dateRange.toDate,
               companyIds: validCompanyIds.join(','),
               accIds: accountId,
               orderBy: 'desc',
               search: searchQuery,
            }),
         );

         // Update local state
         setLocalStyleUpdates((prev) => {
            const updated = { ...prev };
            currentSelectedRows.forEach((row) => {
               const key = `${row.DocType}-${row.docid}`;
               updated[key] = 1; // Set to checked
            });
            return updated;
         });

         setTimeout(() => {
            fetchData(searchQuery);
            setTimeout(() => {
               setLocalStyleUpdates((prev) => {
                  const updated = { ...prev };
                  currentSelectedRows.forEach((row) => {
                     const key = `${row.DocType}-${row.docid}`;
                     delete updated[key];
                  });
                  return updated;
               });
            }, 1000);
         }, 300);
      } catch (error) {
         console.error('Error:', error);
         fetchData(searchQuery);
      }
   }, [selectedRowData, dispatch, searchQuery, fetchData]);

   const handleProblem = useCallback(async () => {
      if (selectedRowData.length === 0) return;

      const checkedStyles = selectedRowData.map((row) => ({
         entryType: row.DocType,
         entryId: row.docid,
         type: 2,
      }));

      const currentSelectedRows = [...selectedRowData];
      setSelectedRows({});
      setSelectedRowData([]);

      try {
         await dispatch(statementCheckedStyle({ checkedStyles }));
         await dispatch(
            getReportLedger({
               fromDate: dateRange.fromDate,
               toDate: dateRange.toDate,
               companyIds: validCompanyIds.join(','),
               accIds: accountId,
               orderBy: 'desc',
               search: searchQuery,
            }),
         );

         // Update local state
         setLocalStyleUpdates((prev) => {
            const updated = { ...prev };
            currentSelectedRows.forEach((row) => {
               const key = `${row.DocType}-${row.docid}`;
               updated[key] = 2; // Set to problem
            });
            return updated;
         });

         setTimeout(() => {
            fetchData(searchQuery);
            setTimeout(() => {
               setLocalStyleUpdates((prev) => {
                  const updated = { ...prev };
                  currentSelectedRows.forEach((row) => {
                     const key = `${row.DocType}-${row.docid}`;
                     delete updated[key];
                  });
                  return updated;
               });
            }, 1000);
         }, 300);
      } catch (error) {
         console.error('Error:', error);
         fetchData(searchQuery);
      }
   }, [selectedRowData, dispatch, searchQuery, fetchData]);

   // Render functions
   const renderDataRow = useCallback(
      (row, idx, accountId) => {
         const rowId = `${accountId}-${idx}`;

         const handledata = async (data, e) => {
            if (
               e.target.type === 'checkbox' ||
               e.target.closest('input[type="checkbox"]') ||
               e.target.closest('[role="checkbox"]')
            ) {
               e.stopPropagation();
               return;
            }

            const storedCompanyId = localStorage.getItem('companyId');
            const companyId = parseInt(storedCompanyId);

            if (companyId === data.companyid && data.daybooktype === 20) {
               setEntityType('receivemaster');
               const response = await dispatch(getReceiveInventory(data.docid));
               await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
               setIsOpenSingleViewinr(true);
            }
            if (companyId === data.companyid && data.daybooktype === 19) {
               setEntityType('issuemaster');
               const response = await dispatch(getIssueInventory(data.docid));
               await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
               setIsOpenSingleViewinr(true);
            }
            if (companyId === data.companyid && data.daybooktype === 11) {
               setEntityType('purchaseinvoice');
               await dispatch(getPurchaseInvoice(data.docid));
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyid && data.daybooktype === 5) {
               setEntityType('saleinvoice');
               await dispatch(getSaleInvoice(data.docid));
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyid && data.daybooktype === 12) {
               setEntityType('purchasereturn');
               await dispatch(getSinglePurchaseReturn(data.docid));
               await dispatch(
                  getSinglePurchaseReturnWithPrevAndNext({
                     id: data.docid,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyid && data.daybooktype === 6) {
               setEntityType('salereturn');
               await dispatch(
                  getSingleSalesReturnWithPrevAndNext({
                     id: data.docid,
                     page: 1,
                     limit: 1,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               setIsOpenPurchaseReturnSingleView(true);
            }
            if (companyId === data.companyid && data.daybooktype === 13) {
               setEntityType('cash');
               setIsBankPageTrue(false);
               await dispatch(getOneVoucher(data.docid));
               setIsOpenSingleViewcnb(true);
            }
            if (companyId === data.companyid && data.daybooktype === 14) {
               setEntityType('bank');
               setIsBankPageTrue(true);
               await dispatch(getOneVoucher(data.docid));
               setIsOpenSingleViewcnb(true);
            }
            if (companyId === data.companyid && data.daybooktype === 18) {
               setEntityTypesv('JV');
               const response = await dispatch(
                  getJournalVoucher({ docNumber: data.docnumber, companyId: user?.loginhistory?.companyId }),
               );
               setCurrentRow(response[0]);
               setisOpenJV(true);
               setIsEditMode(true);
            }
         };

         return (
            <MemoizedDataRow
               key={rowId}
               row={row}
               idx={idx}
               accountId={accountId}
               rowId={rowId}
               isSelected={selectedRows[rowId] || false}
               onSelection={handleRowSelection}
               onRowClick={(data, e) => handledata(data, e)}
               formatDateToDDMMYYYY={formatDateToDDMMYYYY}
               iconColor={iconColor}
               selectedRows={selectedRows}
               formatCellAmount={formatCellAmount}
               localStyleUpdates={localStyleUpdates}
            />
         );
      },
      [formatDateToDDMMYYYY, selectedRows, handleRowSelection, iconColor, dispatch, user, localStyleUpdates],
   );

   const renderAccountData = useCallback(
      (accountData, accountId) => {
         if (isLoading) {
            return (
               <Tr>
                  <Td colSpan={9}>
                     <Loader />
                  </Td>
               </Tr>
            );
         }

         const filteredAccountData = getFilteredAccountData(accountData);

         if (!filteredAccountData.data || filteredAccountData.data.length === 0) {
            return (
               <Tr>
                  <Td colSpan={9} textAlign="center" py="40px">
                     <Text>No transactions found for selected filter</Text>
                  </Td>
               </Tr>
            );
         }

         return <>{filteredAccountData.data.map((row, idx) => renderDataRow(row, idx, accountId))}</>;
      },
      [isLoading, renderDataRow, getFilteredAccountData],
   );

   const renderCompanyData = useCallback(
      (companyData) => {
         return (
            <>
               {companyData.accounts?.map((accountData) => {
                  const accountId = accountData.accountId;
                  const filteredAccountData = getFilteredAccountData(accountData);

                  if (!filteredAccountData.data || filteredAccountData.data.length === 0) {
                     return null;
                  }

                  const allRowsSelected = filteredAccountData.data?.every(
                     (row, idx) => selectedRows[`${accountId}-${idx}`],
                  );

                  return (
                     <React.Fragment key={`account-${accountId}`}>
                        {/* Account Header Row */}
                        <Tr
                           className={`cursor-pointer transition-all duration-300 group ${
                              isDark
                                 ? 'bg-gradient-to-r from-indigo-950 via-indigo-900 to-indigo-950 border-l-indigo-400 hover:from-indigo-900 hover:via-indigo-800 hover:to-indigo-900 shadow-lg shadow-indigo-900/30'
                                 : 'bg-gradient-to-r from-blue-50 via-indigo-50 to-blue-50 border-l-blue-500 hover:from-blue-100 hover:via-indigo-100 hover:to-blue-100 shadow-md shadow-blue-200/50'
                           }`}
                           onClick={() => toggleExpand(`account-${accountId}`)}>
                           <Td colSpan={2} py={3} px={0}>
                              <div className="flex justify-between items-center">
                                 <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                                    <div
                                       className={`w-1.5 h-12 rounded-full ${
                                          isDark
                                             ? 'bg-gradient-to-b from-indigo-400 to-indigo-500'
                                             : 'bg-gradient-to-b from-indigo-600 to-indigo-700'
                                       }`}
                                    />
                                    <span
                                       className={`font-bold text-[15px] tracking-wide ${
                                          isDark ? 'text-indigo-100' : 'text-indigo-900'
                                       }`}>
                                       {accountData.accountName}
                                    </span>
                                    <div
                                       className={`flex items-center gap-2 px-3 py-1 rounded-full text-[13px] font-semibold ${
                                          isDark
                                             ? 'bg-indigo-800/50 text-indigo-200 border border-indigo-600/30'
                                             : 'bg-white text-indigo-700 border border-indigo-200 shadow-sm'
                                       }`}>
                                       <span
                                          className={`text-[11px] font-medium ${
                                             isDark ? 'text-indigo-400' : 'text-indigo-500'
                                          }`}>
                                          Opening:
                                       </span>
                                       <span className="font-bold">
                                          ₹{Math.abs(accountData.openingBalance).toLocaleString('en-IN')}
                                       </span>
                                       <span
                                          className={`text-[11px] px-1.5 py-0.5 rounded font-bold ${
                                             accountData.openingBalance >= 0
                                                ? isDark
                                                   ? 'bg-emerald-900/50 text-emerald-300'
                                                   : 'bg-emerald-100 text-emerald-700'
                                                : isDark
                                                ? 'bg-rose-900/50 text-rose-300'
                                                : 'bg-rose-100 text-rose-700'
                                          }`}>
                                          {accountData.openingBalance >= 0 ? 'CR' : 'DB'}
                                       </span>
                                    </div>
                                 </div>
                              </div>
                           </Td>
                           <Td colSpan={4} py={3} px={3} />
                           <Td
                              py={3}
                              px={3}
                              width="120px"
                              className={`font-bold text-[14px] text-right ${
                                 isDark ? 'text-emerald-300' : 'text-emerald-700'
                              }`}>
                              ₹
                              {filteredAccountData.data
                                 .filter((row) => row.txnType === 1)
                                 .reduce((sum, row) => sum + Math.abs(row.amount || 0), 0)
                                 .toLocaleString('en-IN')}
                           </Td>
                           <Td
                              py={3}
                              px={3}
                              width="120px"
                              className={`font-bold text-[14px] text-right ${
                                 isDark ? 'text-rose-300' : 'text-rose-700'
                              }`}>
                              ₹
                              {filteredAccountData.data
                                 .filter((row) => row.txnType === 0)
                                 .reduce((sum, row) => sum + Math.abs(row.amount || 0), 0)
                                 .toLocaleString('en-IN')}
                           </Td>
                           <Td py={3} px={3} width="140px" className={`font-bold text-[14px] text-right`}>
                              <div className="flex items-center justify-end gap-3">
                                 <div
                                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-bold ${
                                       isDark
                                          ? 'bg-indigo-800/50 text-indigo-100 border border-indigo-600/30'
                                          : 'bg-white text-indigo-900 border border-indigo-200 shadow-sm'
                                    }`}>
                                    <span>₹</span>
                                    <span>
                                       {filteredAccountData.data.length > 0
                                          ? Math.abs(filteredAccountData.data[0].bal).toLocaleString('en-IN')
                                          : Math.abs(accountData.openingBalance).toLocaleString('en-IN')}
                                    </span>
                                    <span
                                       className={`text-[11px] ml-1 px-1.5 py-0.5 rounded font-bold ${
                                          (filteredAccountData.data.length > 0
                                             ? filteredAccountData.data[0].bal
                                             : accountData.openingBalance) < 0
                                             ? isDark
                                                ? 'bg-rose-900/50 text-rose-300'
                                                : 'bg-rose-100 text-rose-700'
                                             : isDark
                                             ? 'bg-emerald-900/50 text-emerald-300'
                                             : 'bg-emerald-100 text-emerald-700'
                                       }`}>
                                       {(filteredAccountData.data.length > 0
                                          ? filteredAccountData.data[0].bal
                                          : accountData.openingBalance) < 0
                                          ? 'DB'
                                          : 'CR'}
                                    </span>
                                 </div>
                                 <span
                                    className={`transform transition-transform duration-300 ${
                                       expandedItems[`account-${accountId}`] ? 'rotate-180' : ''
                                    } ${isDark ? 'text-indigo-300' : 'text-indigo-600'}`}>
                                    {expandedItems[`account-${accountId}`] ? (
                                       <ChevronUpIcon size={20} className="font-bold" />
                                    ) : (
                                       <ChevronDownIcon size={20} className="font-bold" />
                                    )}
                                 </span>
                              </div>
                           </Td>
                        </Tr>

                        {/* Column Headers - when expanded */}
                        {expandedItems[`account-${accountId}`] && (
                           <Tr
                              className={`sticky top-[-1px] z-[1] border-b-2 ${
                                 isDark
                                    ? 'bg-slate-900 border-b-slate-700 shadow-lg shadow-slate-900/50'
                                    : 'bg-slate-50 border-b-slate-300 shadow-md shadow-slate-200/50'
                              }`}>
                              <Th
                                 py={2}
                                 px={3}
                                 width="50px"
                                 className={`text-[13px] font-bold tracking-wide ${
                                    isDark ? 'text-slate-300' : 'text-slate-700'
                                 }`}>
                                 <div className="flex items-center gap-1">
                                    <Checkbox
                                       isChecked={allRowsSelected}
                                       onChange={(e) => {
                                          e.stopPropagation();
                                          handleSelectAllAccount(accountId, filteredAccountData, e.target.checked);
                                       }}
                                       colorScheme="blue"
                                       size="md"
                                    />
                                    <div className="relative group">
                                       <button
                                          className={`p-1 rounded hover:bg-opacity-20 ${
                                             isDark ? 'hover:bg-white text-white' : 'hover:bg-gray-300 text-gray-600'
                                          } transition-colors`}>
                                          <ChevronDownIcon boxSize={3} />
                                       </button>
                                       <div
                                          className={`absolute left-0 top-full mt-1 w-48 rounded-lg shadow-2xl border z-50 transform origin-top scale-95 opacity-0 invisible group-hover:scale-100 group-hover:opacity-100 group-hover:visible transition-all duration-200 ${
                                             isDark ? 'bg-slate-800 border-slate-600' : 'bg-white border-gray-200'
                                          }`}>
                                          <div className="py-1">
                                             <button
                                                onClick={handleSelectAll}
                                                disabled={statusCounts.all === 0}
                                                className={`w-full text-left px-4 py-2 flex items-center justify-between transition-all ${
                                                   statusCounts.all === 0
                                                      ? isDark
                                                         ? 'opacity-40 cursor-not-allowed text-gray-500'
                                                         : 'opacity-40 cursor-not-allowed text-gray-400'
                                                      : isDark
                                                      ? 'hover:bg-slate-700 text-white hover:bg-opacity-50'
                                                      : 'hover:bg-blue-50 text-gray-900 hover:bg-opacity-50'
                                                }`}>
                                                <div className="flex items-center gap-3">
                                                   <div className={`w-3 h-3 rounded-full bg-gray-400`}></div>
                                                   <span>All</span>
                                                </div>
                                                <span
                                                   className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                                   {statusCounts.all}
                                                </span>
                                             </button>

                                             <button
                                                onClick={handleSelectChecked}
                                                disabled={statusCounts.checked === 0}
                                                className={`w-full text-left px-4 py-2 flex items-center justify-between transition-all ${
                                                   statusCounts.checked === 0
                                                      ? isDark
                                                         ? 'opacity-40 cursor-not-allowed text-gray-500'
                                                         : 'opacity-40 cursor-not-allowed text-gray-400'
                                                      : isDark
                                                      ? 'hover:bg-slate-700 text-white hover:bg-opacity-50'
                                                      : 'hover:bg-blue-50 text-gray-900 hover:bg-opacity-50'
                                                }`}>
                                                <div className="flex items-center gap-3">
                                                   <div
                                                      className={`w-3 h-3 rounded-full ${
                                                         statusCounts.checked === 0 ? 'bg-gray-500' : 'bg-green-500'
                                                      }`}></div>
                                                   <span>Checked</span>
                                                </div>
                                                <span
                                                   className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                                   {statusCounts.checked}
                                                </span>
                                             </button>

                                             <button
                                                onClick={handleSelectProblem}
                                                disabled={statusCounts.problem === 0}
                                                className={`w-full text-left px-4 py-2 flex items-center justify-between transition-all ${
                                                   statusCounts.problem === 0
                                                      ? isDark
                                                         ? 'opacity-40 cursor-not-allowed text-gray-500'
                                                         : 'opacity-40 cursor-not-allowed text-gray-400'
                                                      : isDark
                                                      ? 'hover:bg-slate-700 text-white hover:bg-opacity-50'
                                                      : 'hover:bg-blue-50 text-gray-900 hover:bg-opacity-50'
                                                }`}>
                                                <div className="flex items-center gap-3">
                                                   <div
                                                      className={`w-3 h-3 rounded-full ${
                                                         statusCounts.problem === 0 ? 'bg-gray-500' : 'bg-red-500'
                                                      }`}></div>
                                                   <span>Problem</span>
                                                </div>
                                                <span
                                                   className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                                   {statusCounts.problem}
                                                </span>
                                             </button>

                                             <button
                                                onClick={handleSelectUnchecked}
                                                disabled={statusCounts.unchecked === 0}
                                                className={`w-full text-left px-4 py-2 flex items-center justify-between transition-all ${
                                                   statusCounts.unchecked === 0
                                                      ? isDark
                                                         ? 'opacity-40 cursor-not-allowed text-gray-500'
                                                         : 'opacity-40 cursor-not-allowed text-gray-400'
                                                      : isDark
                                                      ? 'hover:bg-slate-700 text-white hover:bg-opacity-50'
                                                      : 'hover:bg-blue-50 text-gray-900 hover:bg-opacity-50'
                                                }`}>
                                                <div className="flex items-center gap-3">
                                                   <div
                                                      className={`w-3 h-3 rounded-full ${
                                                         statusCounts.unchecked === 0 ? 'bg-gray-500' : 'bg-yellow-500'
                                                      }`}></div>
                                                   <span>Un-Checked</span>
                                                </div>
                                                <span
                                                   className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                                   {statusCounts.unchecked}
                                                </span>
                                             </button>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </Th>
                              <Th
                                 py={2}
                                 px={6}
                                 width="110px"
                                 className={`text-[13px] font-bold tracking-wide text-left ${
                                    isDark ? 'text-slate-300' : 'text-slate-700'
                                 }`}>
                                 Date
                              </Th>
                              <Th
                                 py={2}
                                 px={3}
                                 width="80px"
                                 className={`text-[13px] font-bold tracking-wide text-left ${
                                    isDark ? 'text-slate-300' : 'text-slate-700'
                                 }`}>
                                 Doc#
                              </Th>
                              <Th
                                 py={2}
                                 px={3}
                                 width="180px"
                                 className={`text-[13px] font-bold tracking-wide text-left ${
                                    isDark ? 'text-slate-300' : 'text-slate-700'
                                 }`}>
                                 Daybook
                              </Th>
                              <Th
                                 py={2}
                                 px={3}
                                 width="180px"
                                 className={`text-[13px] font-bold tracking-wide text-left ${
                                    isDark ? 'text-slate-300' : 'text-slate-700'
                                 }`}>
                                 Contra Account
                              </Th>
                              <Th
                                 py={2}
                                 px={3}
                                 width={'180px'}
                                 className={`text-[13px] font-bold tracking-wide text-left ${
                                    isDark ? 'text-slate-300' : 'text-slate-700'
                                 }`}>
                                 Particulars
                              </Th>
                              <Th
                                 py={2}
                                 px={3}
                                 isNumeric
                                 width="120px"
                                 className={`text-[13px] font-bold tracking-wide text-right ${
                                    isDark ? 'text-emerald-400' : 'text-emerald-700'
                                 }`}>
                                 Debit
                              </Th>
                              <Th
                                 py={2}
                                 px={3}
                                 width="120px"
                                 isNumeric
                                 className={`text-[13px] font-bold tracking-wide text-right ${
                                    isDark ? 'text-rose-400' : 'text-rose-700'
                                 }`}>
                                 Credit
                              </Th>
                              <Th
                                 py={2}
                                 px={3}
                                 width="140px"
                                 isNumeric
                                 className={`text-[13px] font-bold tracking-wide text-right ${
                                    isDark ? 'text-indigo-400' : 'text-indigo-700'
                                 }`}>
                                 Balance
                              </Th>
                           </Tr>
                        )}

                        {/* Data Rows */}
                        {expandedItems[`account-${accountId}`] && renderAccountData(accountData, accountId)}
                     </React.Fragment>
                  );
               })}
            </>
         );
      },
      [expandedItems, renderAccountData, toggleExpand, isDark, selectedRows, handleSelectAllAccount],
   );

   // Memoized report data
   const memoizedReportData = useMemo(() => {
      if (!processedLedger || processedLedger.length === 0) return null;

      return processedLedger.map((companyData, companyIndex) => (
         <React.Fragment key={`company-${companyData.companyId || companyIndex}`}>
            {/* Company Header Row - Ultra Premium Design */}
            <Tr
               className={`cursor-pointer transition-all duration-300 group ${
                  isDark
                     ? 'bg-gradient-to-r from-rose-950 via-grey-900 to-rose-950 border-l-rose-400 hover:from-rose-900 hover:via-grey-800 hover:to-rose-900 shadow-xl shadow-rose-900/40'
                     : 'bg-gradient-to-r from-rose-100 via-grey-100 to-rose-100 border-l-rose-600 hover:from-rose-200 hover:via-grey-200 hover:to-rose-200 shadow-lg shadow-rose-300/60'
               }`}
               onClick={() => toggleExpand(`company-${companyData.companyId}`)}>
               <Td colSpan={9} p="0">
                  <div className="flex justify-between items-center">
                     <div className="flex items-center gap-4">
                        <div
                           className={`w-1.5 h-12 rounded-full ${
                              isDark
                                 ? 'bg-gradient-to-b from-rose-400 to-grey-500'
                                 : 'bg-gradient-to-b from-rose-600 to-rose-700'
                           }`}
                        />
                        <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                           <span
                              className={`font-black text-[17px] tracking-wide ${
                                 isDark ? 'text-rose-50' : 'text-rose-900'
                              }`}>
                              {companyData.companyName}
                           </span>
                        </div>
                     </div>
                     <div className="flex items-center gap-3">
                        <div
                           className={`px-3 py-1 rounded-lg font-bold text-[13px] ${
                              isDark
                                 ? 'bg-rose-800/50 text-rose-100 border border-rose-600/30'
                                 : 'bg-white text-rose-900 border-2 border-rose-300 shadow-sm'
                           }`}>
                           {companyData.accounts?.length || 0} Account{companyData.accounts?.length !== 1 ? 's' : ''}
                        </div>
                        <span
                           className={`transform transition-transform duration-300 p-2 rounded-full ${
                              expandedItems[`company-${companyData.companyId}`]
                                 ? 'rotate-180 bg-rose-500/20'
                                 : 'bg-transparent'
                           } ${isDark ? 'text-rose-300' : 'text-rose-700'}`}>
                           {expandedItems[`company-${companyData.companyId}`] ? (
                              <ChevronUpIcon size={24} className="font-bold" strokeWidth={3} />
                           ) : (
                              <ChevronDownIcon size={24} className="font-bold" strokeWidth={3} />
                           )}
                        </span>
                     </div>
                  </div>
               </Td>
            </Tr>

            {expandedItems[`company-${companyData.companyId}`] && renderCompanyData(companyData)}
         </React.Fragment>
      ));
   }, [processedLedger, expandedItems, renderCompanyData, toggleExpand, isDark]);

   const selectedbgColor = useColorModeValue('#d2e0f4ff', '#1A365D');
   const focusedbgColor = useColorModeValue('#d2e0f4ff', '#2D3748');
   const optionbgColor = useColorModeValue('#ffffff', '#1A202C');
   const optionTextColor = useColorModeValue('#000000', '#ffffff');
   const bgcolor1 = useColorModeValue('#ffffff', '#1A202C');

   const startEditing = async (id, rowData) => {
      await dispatch(
         getDaybookForPayments({
            type: isBankPageTrue ? 14 : 13,
            companyId: user?.loginhistory?.companyId,
            ...(shouldSendIdInDaybook && { companyIds: user?.loginhistory?.companyId }),
         }),
      );
      const selectAcc = accountData.filter((acc) => acc.id === rowData.accountId);
      setSelectedEditAccount(selectAcc[0]);
      setFormData((prev) => ({
         ...prev,
         id,
         ...rowData,
      }));
      setIsOutstandingModalOpen(true);
      setUpdateFormLoading(true);
   };

   const handleClearData = () => {
      setPendingVoucher([]);
      setFormData({
         companyId: parseInt(localStorage.getItem('companyId')),
         txnDate: new Date().toISOString().split('T')[0],
         daybookId: daybookTypeData?.length === 1 ? daybookTypeData[0].id : '',
         docNumber: 0,
         txnType: `${transactionType === 'payment' ? 1 : 0}`,
         accountId: null,
         amount: receivedAmount,
         brokerId: null,
         supplierId: 0,
         chequeNo: 0,
         transactionNo: 0,
         bankId: 0,
         bankBranchId: 0,
         particulars: '',
         depositeDate: '',
         clearingDate: '',
         tdsApplicable: false,
         tdsAccountId: 0,
         tdsLimit: 0,
         tdsRate: 0,
         tdsCess: 0,
         tdsSurcharge: 0,
         tdsAmount: 0,
         tdsCessAmount: 0,
         tdsSurchargeAmount: 0,
         tdsHCessAmount: 0,
         tdsInterestAmount: 0,
         tdsPenaltyAmount: 0,
         tdsOthersAmount: 0,
         notes1: '',
         notes2: '',
         notes3: '',
         notes4: '',
         notes5: '',
         userNote: '',
         taxableValue: '',
         GSTAmount: 0,
         stateOfSupply: 0,
         isRCM: false,
         GSTSubTxnType: 0,
         HSNSACId: 0,
         typeofSupply: 0,
         partyBillNo: 0,
         GSTTxnType: 0,
         outAdjustments: [],
      });
      setReceivedAmount(0);
      setTotalPendingAccount(0);
   };

   const handleSave = async () => {};

   const handleViewSingleData = async (id) => {
      await dispatch(getReceiveInventory(id));
      setIsOpenSingleViewinr(true);
   };
   const handleSalesSingleDataViewClose = () => {
      setIsOpenSingleViewinr();
   };

   const deletePurchaseReturn = () => {
      const selectedDaybook = daybookData.find((db) => db.id === viewDetail?.daybookId);
      if (entityType === 'purchasereturn') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId(viewDetail?.id);
            setIsModalOpen(true);
         } else {
            deleteRecord(
               viewDetail?.id,
               deletePurchaseReturnInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecord(viewDetail?.id, deletePurchaseReturnInvoice, dispatch);
      }
      if (entityType === 'salereturn') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId(viewDetail?.id);
            setIsModalOpen(true);
         } else {
            deleteRecord(
               viewDetail?.id,
               deleteSaleReturnInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecord(viewDetail?.id, deleteSaleReturnInvoice, dispatch);
      }
      if (entityType === 'saleinvoice') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
            setIsModalOpen(true);
         } else {
            deleteRecordForSales(
               viewDetail?.id,
               viewDetail?.daybookId,
               viewDetail?.accountId,
               deleteSaleInvoice,
               dispatch,
               storedCompanyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecord(viewDetail?.id, deleteSaleInvoice, dispatch);
         // deleteRecordForSales(
         //    viewDetail?.id,
         //    viewDetail?.daybookId,
         //    viewDetail?.accountId,
         //    deleteSaleInvoice,
         //    dispatch,
         //    storedCompanyId,
         // );
      }
      if (entityType === 'purchaseinvoice') {
         if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
            setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
            setIsModalOpen(true);
         } else {
            deleteRecordForSales(
               viewDetail?.id,
               viewDetail.daybookId,
               viewDetail.accountId,
               deletePurchaseInvoice,
               dispatch,
               user?.loginhistory?.companyId,
               userGlobalSettingsData,
            );
         }
         // deleteRecord(viewDetail?.id, deletePurchaseInvoice, dispatch);
         // deleteRecordForSales(
         //    viewDetail?.id,
         //    viewDetail?.daybookId,
         //    viewDetail?.accountId,
         //    deletePurchaseInvoice,
         //    dispatch,
         //    storedCompanyId,
         // );
      }
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   const handleNextPage = () => {
      console.log('Next');
   };
   const handlePrevPage = () => {
      console.log('Prev');
   };

   const downloadExcel = () => {
      if (processedLedger.length > 0) {
         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light rose for totals
            headerText: '000000', // Black for header text
         };

         const headers = ['Date', 'Doc', 'Daybook', 'ContraAccount', 'Particulars', 'Debit', 'Credit', 'Balance'];
         const finalData = [];
         const styles = [];

         processedLedger.forEach((ProfitLossdata) => {
            // finalData.push([`${ProfitLossdata.companyName}`]);
            const companyNameRow = Array(headers.length).fill('');
            companyNameRow[0] = ProfitLossdata.companyName;
            finalData.push(companyNameRow);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F8FAFC' } },
                  alignment: { horizontal: 'left' },
               }),
            );

            ProfitLossdata.accounts.forEach((group) => {
               const totalcd = group.data
                  .filter((row) => row.txnType === 1)
                  .reduce((sum, row) => sum + Math.abs(row.amount || 0), 0)
                  .toLocaleString('en-IN'); // Optional: use 'en-IN' for Indian format like 1,23,456

               const totaldb = group.data
                  .filter((row) => row.txnType === 0)
                  .reduce((sum, row) => sum + Math.abs(row.amount || 0), 0)
                  .toLocaleString('en-IN'); // Optional: use 'en-IN' for Indian format like 1,23,456

               const totalbal = group.data.length > 0 ? Math.abs(group.data[0].bal) : Math.abs(group.openingBalance);

               finalData.push([
                  group.accountName + '   ' + 'OpeningBalanc :' + group.openingBalance,
                  '',
                  '',
                  '',
                  '',
                  totalcd,
                  totaldb,
                  totalbal,
               ]);
               styles.push(
                  Array(headers.length).fill({
                     font: { bold: true, sz: 10, color: { rgb: colors.headerText } },
                  }),
               );

               finalData.push(headers);
               styles.push(
                  Array(headers.length).fill({
                     font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
                  }),
               );

               group.data.forEach((groupdata) => {
                  const row = [];
                  const rowStyle = [];
                  row.push(formatDateToDDMMYYYY(groupdata.date) || '');
                  row.push(groupdata.docnumber || '');
                  row.push(groupdata.daybookname || '');
                  row.push(groupdata.finalcontraaccountname || '');
                  row.push(groupdata.particulars || '');
                  row.push(groupdata.txnType === 1 ? Math.abs(groupdata.amount) : '-');
                  row.push(groupdata.txnType === 0 ? Math.abs(groupdata.amount) : '-');
                  row.push(groupdata.bal ? Math.abs(groupdata.bal) : '');

                  finalData.push(row);
                  styles.push(rowStyle);
               });

               finalData.push([]);
               styles.push([]);
            });

            finalData.push([]);
            styles.push([]);
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [
            { width: 40 },
            { width: 10 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
         ];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Statement');
         XLSX.writeFile(wb, 'Statement.xlsx');
      } else {
      }
   };

   const downloadPDF = () => {
      if (processedLedger.length === 0) return;

      // Create a new PDF document in landscape orientation
      const doc = new jsPDF({
         orientation: 'landscape',
         unit: 'mm',
         format: [297, 210], // A4 landscape
      });

      // Set document properties
      doc.setProperties({
         title: 'Ledger Statement',
         subject: 'Ledger Details',
         author: 'OB MOBILE GALLERY',
      });

      // Helper function to calculate optimal column widths
      const calculateColumnWidths = (data) => {
         doc.setFontSize(7);

         const minWidths = {
            date: 20,
            docNumber: 18,
            daybook: 25,
            contraAccount: 35,
            particulars: 40,
            debit: 25,
            credit: 25,
            balance: 28,
         };

         const maxWidths = {
            date: 25,
            docNumber: 25,
            daybook: 45,
            contraAccount: 70,
            particulars: 90,
            debit: 30,
            credit: 30,
            balance: 35,
         };

         let widths = { ...minWidths };
         const padding = 4;

         data.forEach((row) => {
            // Measure actual text widths
            const dateWidth = doc.getTextWidth(formatDateToDDMMYYYY(row.date) || '-') + padding;
            const docWidth = doc.getTextWidth(String(row.docnumber || '-')) + padding;
            const daybookWidth = doc.getTextWidth(row.daybookname || '-') + padding;
            const contraWidth = doc.getTextWidth(row.finalcontraaccountname || '-') + padding;
            const particularsWidth = doc.getTextWidth(row.particulars || '-') + padding;
            const debitWidth =
               row.txnType === 1
                  ? doc.getTextWidth(Math.abs(row.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })) +
                    padding
                  : doc.getTextWidth('-') + padding;
            const creditWidth =
               row.txnType === 0
                  ? doc.getTextWidth(Math.abs(row.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })) +
                    padding
                  : doc.getTextWidth('-') + padding;
            const balWidth =
               doc.getTextWidth(
                  `${Math.abs(row.bal).toLocaleString('en-IN', { minimumFractionDigits: 2 })} ${
                     row.bal < 0 ? 'DB' : 'CR'
                  }`,
               ) + padding;

            // Update widths if current content is wider
            widths.date = Math.min(Math.max(widths.date, dateWidth), maxWidths.date);
            widths.docNumber = Math.min(Math.max(widths.docNumber, docWidth), maxWidths.docNumber);
            widths.daybook = Math.min(Math.max(widths.daybook, daybookWidth), maxWidths.daybook);
            widths.contraAccount = Math.min(Math.max(widths.contraAccount, contraWidth), maxWidths.contraAccount);
            widths.particulars = Math.min(Math.max(widths.particulars, particularsWidth), maxWidths.particulars);
            widths.debit = Math.min(Math.max(widths.debit, debitWidth), maxWidths.debit);
            widths.credit = Math.min(Math.max(widths.credit, creditWidth), maxWidths.credit);
            widths.balance = Math.min(Math.max(widths.balance, balWidth), maxWidths.balance);
         });

         // Calculate column positions
         const leftMargin = 5;
         const totalAvailableWidth = 287;

         const positions = {
            date: leftMargin,
            docNumber: 0,
            daybook: 0,
            contraAccount: 0,
            particulars: 0,
            debit: 0,
            credit: 0,
            balance: 0,
         };

         positions.docNumber = positions.date + widths.date;
         positions.daybook = positions.docNumber + widths.docNumber;
         positions.contraAccount = positions.daybook + widths.daybook;
         positions.particulars = positions.contraAccount + widths.contraAccount;
         positions.debit = positions.particulars + widths.particulars;
         positions.credit = positions.debit + widths.debit;
         positions.balance = positions.credit + widths.credit;

         return { widths, positions };
      };

      let currentY = 10;

      // Add title
      doc.setFontSize(16);
      doc.setTextColor(0, 0, 0);
      doc.text('Ledger Statement', 148.5, currentY, { align: 'center' });
      currentY += 10;

      processedLedger.forEach((company) => {
         // Add company header
         doc.setFillColor(241, 240, 232);
         doc.rect(5, currentY, 287, 8, 'F');
         doc.setFontSize(12);
         doc.setTextColor(0, 0, 0);
         doc.text(company.companyName, 8, currentY + 5);
         currentY += 10;

         company.accounts.forEach((account) => {
            // Calculate optimal widths for this account's data
            const { widths, positions } = calculateColumnWidths(account.data);

            // Calculate totals
            const totalDebit = account.data
               .filter((row) => row.txnType === 1)
               .reduce((sum, row) => sum + Math.abs(row.amount || 0), 0);

            const totalCredit = account.data
               .filter((row) => row.txnType === 0)
               .reduce((sum, row) => sum + Math.abs(row.amount || 0), 0);

            const closingBalance = account.data.length > 0 ? account.data[0].bal : account.openingBalance;

            // Check if we need a new page before account header
            if (currentY > 180) {
               doc.addPage('landscape');
               currentY = 20;
            }

            // Add account header with totals
            doc.setFillColor(248, 250, 252);
            doc.rect(5, currentY, 287, 8, 'F');
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);

            // Account name and opening balance
            const accountHeaderText = `${account.accountName} - Opening: ${Math.abs(
               account.openingBalance,
            ).toLocaleString('en-IN')} ${account.openingBalance >= 0 ? 'CR' : 'DB'}`;
            doc.text(accountHeaderText, 8, currentY + 5);

            // Totals on the right
            doc.setFontSize(9);
            doc.text(`DB: ${totalDebit.toLocaleString('en-IN')}`, 190, currentY + 5);
            doc.text(`CR: ${totalCredit.toLocaleString('en-IN')}`, 225, currentY + 5);
            doc.text(
               `Bal: ${Math.abs(closingBalance).toLocaleString('en-IN')} ${closingBalance < 0 ? 'DB' : 'CR'}`,
               288,
               currentY + 5,
               { align: 'right' },
            );

            currentY += 10;

            // Add column headers with dynamic widths
            doc.setFillColor(200, 200, 200);
            doc.rect(5, currentY, 287, 6, 'F');
            doc.setFontSize(7);
            doc.setTextColor(0, 0, 0);

            doc.text('Date', positions.date + 1, currentY + 4);
            doc.text('Doc #', positions.docNumber + 1, currentY + 4);
            doc.text('Daybook', positions.daybook + 1, currentY + 4);
            doc.text('Contra Account', positions.contraAccount + 1, currentY + 4);
            doc.text('Particulars', positions.particulars + 1, currentY + 4);
            doc.text('Debit', positions.credit - 2, currentY + 4, { align: 'right' });
            doc.text('Credit', positions.balance - 2, currentY + 4, { align: 'right' });
            doc.text('Balance', 288, currentY + 4, { align: 'right' });

            currentY += 8;

            // Add transaction rows
            account.data.forEach((row, index) => {
               doc.setFontSize(7);

               // Calculate row height based on wrapped text
               const particularsText = row.particulars || '-';
               const particularsLines =
                  particularsText === '-' ? ['-'] : doc.splitTextToSize(particularsText, widths.particulars - 2);
               const contraLines = doc.splitTextToSize(row.finalcontraaccountname || '-', widths.contraAccount - 2);
               const daybookLines = doc.splitTextToSize(row.daybookname || '-', widths.daybook - 2);

               const maxLines = Math.max(particularsLines.length, contraLines.length, daybookLines.length);
               const rowHeight = Math.max(6, 3 + maxLines * 3);

               // Check if we need a new page
               if (currentY + rowHeight > 190) {
                  doc.addPage('landscape');
                  currentY = 20;

                  // Repeat column headers on new page
                  doc.setFillColor(200, 200, 200);
                  doc.rect(5, currentY, 287, 6, 'F');
                  doc.setFontSize(7);
                  doc.setTextColor(0, 0, 0);
                  doc.text('Date', positions.date + 1, currentY + 4);
                  doc.text('Doc #', positions.docNumber + 1, currentY + 4);
                  doc.text('Daybook', positions.daybook + 1, currentY + 4);
                  doc.text('Contra Account', positions.contraAccount + 1, currentY + 4);
                  doc.text('Particulars', positions.particulars + 1, currentY + 4);
                  doc.text('Debit', positions.credit - 2, currentY + 4, { align: 'right' });
                  doc.text('Credit', positions.balance - 2, currentY + 4, { align: 'right' });
                  doc.text('Balance', 288, currentY + 4, { align: 'right' });
                  currentY += 8;
               }

               // Alternate row colors
               if (index % 2 === 0) {
                  doc.setFillColor(255, 255, 255);
               } else {
                  doc.setFillColor(245, 245, 245);
               }
               doc.rect(5, currentY, 287, rowHeight, 'F');

               doc.setFontSize(7);
               doc.setTextColor(0, 0, 0);

               const baseY = currentY + 3.5;

               // Date
               doc.text(formatDateToDDMMYYYY(row.date) || '-', positions.date + 1, baseY);

               // Doc #
               doc.text(String(row.docnumber || '-'), positions.docNumber + 1, baseY);

               // Daybook - wrap if needed
               doc.text(daybookLines, positions.daybook + 1, baseY);

               // Contra Account - wrap if needed
               doc.text(contraLines, positions.contraAccount + 1, baseY);

               // Particulars - wrap with all lines shown
               doc.text(particularsLines, positions.particulars + 1, baseY);

               // Debit (right-aligned)
               doc.text(
                  row.txnType === 1
                     ? `${Math.abs(row.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`
                     : '-',
                  positions.credit - 2,
                  baseY,
                  { align: 'right' },
               );

               // Credit (right-aligned)
               doc.text(
                  row.txnType === 0
                     ? `${Math.abs(row.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`
                     : '-',
                  positions.balance - 2,
                  baseY,
                  { align: 'right' },
               );

               // Balance (right-aligned)
               const absBal = Math.abs(row.bal);
               doc.text(
                  `${absBal.toLocaleString('en-IN', { minimumFractionDigits: 2 })} ${row.bal < 0 ? 'DB' : 'CR'}`,
                  288,
                  baseY,
                  { align: 'right' },
               );

               currentY += rowHeight;
            });

            // Add space between accounts
            currentY += 8;
         });

         // Add space between companies
         currentY += 5;
      });

      // Add page numbers
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
         doc.setPage(i);
         doc.setFontSize(7);
         doc.setTextColor(100, 100, 100);
         doc.text(`Page ${i} of ${pageCount}`, 148.5, 205, { align: 'center' });
      }

      // Save the PDF
      doc.save(`Ledger_Statement_${new Date().toISOString().split('T')[0]}.pdf`);
   };

   return (
      <>
         {/* Header */}
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="40px" overflow={'hidden'} py={2}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Statement Detail
               </Text>
            </Flex>
            {/* Action Buttons */}
            <div className="flex gap-2">
               <button
                  onClick={handleUnchecked}
                  disabled={selectedRowData.length === 0}
                  className={`px-6 py-2 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center space-x-2 focus:outline-none focus:ring-4 focus:ring-yellow-300 ${
                     selectedRowData.length === 0 ? 'opacity-50 cursor-not-allowed' : ''
                  }`}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                     <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clipRule="evenodd"
                     />
                  </svg>
                  <span>Un-Checked ({selectedRowData.length})</span>
               </button>

               <button
                  onClick={handleChecked}
                  disabled={selectedRowData.length === 0}
                  className={`px-6 py-2 bg-gradient-to-r from-green-400 to-emerald-500 hover:from-green-500 hover:to-emerald-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center space-x-2 focus:outline-none focus:ring-4 focus:ring-green-300 ${
                     selectedRowData.length === 0 ? 'opacity-50 cursor-not-allowed' : ''
                  }`}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                     <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                     />
                  </svg>
                  <span>Checked ({selectedRowData.length})</span>
               </button>

               <button
                  onClick={handleProblem}
                  disabled={selectedRowData.length === 0}
                  className={`px-6 py-2 bg-gradient-to-r from-red-500 to-rose-600 hover:from-red-600 hover:to-rose-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center space-x-2 focus:outline-none focus:ring-4 focus:ring-red-300 ${
                     selectedRowData.length === 0 ? 'opacity-50 cursor-not-allowed' : ''
                  }`}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                     <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                     />
                  </svg>
                  <span>Problem ({selectedRowData.length})</span>
               </button>
            </div>
         </Flex>

         {/* Filters */}
         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent="end">
               <Flex flex="" gap={2} mr={3} display={{ base: 'none', xl: 'block' }}>
                  <Box my={2} width="300px" fontSize={'13px'} fontWeight={500} display={{ base: 'none', lg: 'block' }}>
                     <GridItem className="seperator-width" w={'100%'} mt={5}>
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </Flex>
               <Flex flex="" gap={2} mr={3} zIndex={3} display={{ base: 'none', xl: 'block' }}>
                  <Box my={2} width="300px" fontSize={'13px'} fontWeight={500}>
                     <label>Account</label>
                     <Select
                        placeholder="Select Account"
                        name="accountId"
                        options={accountOptions}
                        onChange={handleAccountChange}
                        value={accountOptions.find((option) => option.value === accountId)}
                        isMulti={false}
                        isClearable
                        className="basic-multi-select"
                        classNamePrefix="select"
                        filterOption={(option, searchInput) => {
                           if (!searchInput) return true;
                           const search = searchInput.trim();

                           const { label, value, gstRegNo, email, panNo, mobile, ownerName } = option.data;

                           return (
                              label.toLowerCase().includes(search.toLowerCase()) ||
                              value.toString().toLowerCase().includes(search.toLowerCase()) ||
                              (gstRegNo && gstRegNo.toString().toLowerCase().includes(search.toLowerCase())) ||
                              (email && email.toString().toLowerCase().includes(search.toLowerCase())) ||
                              (panNo && panNo.toString().toLowerCase().includes(search.toLowerCase())) ||
                              (mobile && mobile.toString().toLowerCase().includes(search.toLowerCase())) ||
                              (ownerName && ownerName.toString().toLowerCase().includes(search.toLowerCase()))
                           );
                        }}
                        styles={{
                           control: (baseStyles) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                           }),
                           menu: (base) => ({
                              ...base,
                              // zIndex: 9999,
                              // position: 'absolute',
                              // maxHeight: 300,
                              backgroundColor: bgcolor1,
                           }),
                           option: (base, { isFocused, isSelected }) => ({
                              ...base,
                              backgroundColor: isSelected
                                 ? selectedbgColor
                                 : isFocused
                                 ? focusedbgColor
                                 : optionbgColor,
                              color: optionTextColor,
                              cursor: 'pointer',
                              padding: '8px 12px',
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                        }}
                     />
                  </Box>
               </Flex>
               <Flex flex="2" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={
                           dateRange.fromDate && dateRange.toDate
                              ? [new Date(dateRange.fromDate), new Date(dateRange.toDate)]
                              : null
                        }
                        onChange={handleDateRangeChange}
                        style={{ width: 200, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
               </Flex>
               <Flex className="flex flex-wrap gap-2">
                  <Box flex="1" mr={3}>
                     <MotionFlex
                        ref={wrapperRef}
                        align="center"
                        bg={bg}
                        borderRadius="full"
                        cursor="pointer"
                        px={expanded ? 3 : 0}
                        w={expanded ? '250px' : '40px'}
                        h="40px"
                        transition="all 0.3s ease"
                        onClick={() => setExpanded(true)}
                        overflow="hidden">
                        <MotionSearchIcon
                           color={iconColor}
                           animate={{ rotate: expanded ? 0 : 90 }}
                           transition={{ duration: 0.3 }}
                           style={{
                              marginRight: expanded ? '8px' : '0',
                              marginLeft: expanded ? '0' : '10px',
                           }}
                        />
                        {expanded && (
                           <InputGroup width="200px">
                              <Input
                                 placeholder="Search..."
                                 value={searchInput}
                                 onChange={handleSearchChange}
                                 color={iconColor}
                                 variant="unstyled"
                                 _placeholder={{ color: 'gray.400' }}
                              />
                           </InputGroup>
                        )}
                     </MotionFlex>
                  </Box>

                  {/* Refresh Button */}
                  <button
                     onClick={handleRefresh} // Changed from fetchData to handleRefresh
                     className={`h-[40px] px-4 rounded-lg transition-all duration-200 flex items-center gap-2 mr-2 ${
                        isDark
                           ? 'bg-blue-900/50 hover:bg-blue-800 text-blue-200 border-2 border-blue-700'
                           : 'bg-blue-50 hover:bg-blue-100 text-blue-700 border-2 border-blue-200 shadow-md'
                     }`}>
                     <LuRefreshCcw size={20} />
                  </button>

                  {/* Filter Button */}
                  <button
                     onClick={onFilterOpen}
                     className={`h-[40px] px-4 rounded-lg transition-all duration-200 flex items-center gap-2 mr-2 ${
                        isDark
                           ? 'bg-purple-900/50 hover:bg-purple-800 text-purple-200 border-2 border-purple-700'
                           : 'bg-purple-50 hover:bg-purple-100 text-purple-700 border-2 border-purple-200 shadow-md'
                     }`}>
                     <IoFilterOutline size={22} />
                  </button>

                  {/* Download Popover */}
                  <Popover>
                     <PopoverTrigger>
                        <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
                     </PopoverTrigger>
                     <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                        <PopoverBody p="3">
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={downloadExcel}
                              justifyContent="space-between"
                              mb={3}>
                              <img src={xls} alt="Download XLS" width="30px" />
                              Download Excel
                           </Button>
                           <Button
                              width="100%"
                              variant="ghost"
                              _hover={{ bg: 'blue.100' }}
                              onClick={downloadPDF}
                              justifyContent="space-between">
                              <img src={json} alt="Download JSON" width="30px" />
                              Download PDF
                           </Button>
                        </PopoverBody>
                     </PopoverContent>
                  </Popover>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                        <Box my={2} width="100%" fontSize={'13px'} fontWeight={500}>
                           <label>Account</label>
                           <Select
                              placeholder="Select Account"
                              name="accountId"
                              options={accountOptions}
                              onChange={handleAccountChange}
                              value={accountOptions.find((option) => option.value === accountId)}
                              isMulti={false}
                              isClearable
                              className="basic-multi-select"
                              classNamePrefix="select"
                              styles={{
                                 control: (baseStyles) => ({
                                    ...baseStyles,
                                    minHeight: '30px',
                                    height: '30px',
                                 }),
                                 valueContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                    padding: '0 6px',
                                 }),
                                 indicatorsContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                 }),
                              }}
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={
                                 dateRange.fromDate && dateRange.toDate
                                    ? [new Date(dateRange.fromDate), new Date(dateRange.toDate)]
                                    : null
                              }
                              onChange={handleDateRangeChange}
                              style={{ width: 200, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>
                        <Button colorScheme="rose" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         {/* Table */}
         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '75vh', md: '75vh', xl: '75vh' }}
                  maxH={{ base: '75vh', md: '75vh', xl: '75vh' }}>
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     <Tbody>
                        {isLoading ? (
                           <Loader />
                        ) : memoizedReportData ? (
                           memoizedReportData
                        ) : (
                           <Tr>
                              <Td colSpan={9} textAlign="center" py={10}>
                                 <Flex direction="column" align="center" justify="center">
                                    <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                                    <Text mt={4}>No ledger data found</Text>
                                 </Flex>
                              </Td>
                           </Tr>
                        )}
                     </Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         <StatementFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            accountId={accountId}
            entityType="statement"
         />

         {isOpenPurchaseReturnSingleView && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               ) : viewDetail ? (
                  <SalesDetails
                     isOpen={isOpenPurchaseReturnSingleView}
                     onClose={handleSalesDetailsClose}
                     singleEntityRights={
                        saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight
                     }
                     title={
                        entityType === 'saleinvoice'
                           ? 'Sales Invoice'
                           : entityType === 'salereturn'
                           ? 'Sales Return'
                           : entityType === 'purchaseinvoice'
                           ? 'Purchase Invoice'
                           : 'Purchase Return'
                     }
                     entityType={entityType}
                     singleEntity={viewDetail}
                     handlePrevPage={handlePrevPage}
                     handleNextPage={handleNextPage}
                     setIsEditFormOpen={setIsEditFormOpen}
                     setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
                     isEditFormOpen={isEditFormOpen}
                     viewDetail={viewDetail}
                     lineItems={viewDetail?.lineitems}
                     billTerms={viewDetail?.purchasereturnbillteams}
                     onDelete={deletePurchaseReturn}
                     handleSerchClose={() => {
                        console.log('');
                     }}
                  />
               ) : (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               )}
            </div>
         )}

         {updateFormLoading && formData.id && (
            <PaymentcaseFormEdit
               isOutstandingModalOpen={isOutstandingModalOpen}
               setIsOutstandingModalOpen={setIsOutstandingModalOpen}
               daybookTypeData={daybookTypeData}
               validationSchema={validationSchema}
               errors={errors}
               setErrors={setErrors}
               selectedAccount={selectedEditAccount}
               setSelectedAccount={setSelectedEditAccount}
               userData={accountData}
               type={13}
               isEditMode={true}
               receivedAmount={receivedAmount}
               setReceivedAmount={setReceivedAmount}
               totalPendingAccount={totalPendingAccount}
               setTotalPendingAccount={setTotalPendingAccount}
               formData={formData}
               setFormData={setFormData}
               transactionType={transactionType}
               handleClearData={handleClearData}
               pendingVoucher={pendingVoucher}
               setPendingVoucher={setPendingVoucher}
               currentPage={1}
               limit={10}
               companyId={companyId}
               sorting={sorting}
               pagination={10}
            />
         )}

         {isOpenSingleViewcnb && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               ) : singleEntity ? (
                  <ViewSingleCashBankData
                     isOpenSingleView={isOpenSingleViewcnb}
                     onClose={() => setIsOpenSingleViewcnb(false)}
                     singleEntity={singleEntity}
                     formType="voucher"
                     isBankPageTrue={isBankPageTrue}
                     UserRights={(cashPaymentRight && cashReceiveRight) || (bankPaymentRight && bankReceiveRight)}
                     paymentRight={cashPaymentRight || bankPaymentRight}
                     receiveRight={cashReceiveRight || bankReceiveRight}
                     startEditing={(data) => startEditing(data.id, data)}
                  />
               ) : (
                  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]">
                     <Loader />
                  </div>
               )}
            </div>
         )}

         <JournalVoucherForm
            isOpen={isOpenJV}
            onClose={() => setisOpenJV(false)}
            isEditMode={isEditMode}
            currentRow={currentRow}
            onSave={handleSave}
         />

         <DeletePasswordModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={
               entityType === 'saleinvoice' || entityType === 'purchaseinvoice' ? deleteRecordForSales : deleteRecord
            }
            id={dataId}
            deleteApi={
               entityType === 'saleinvoice'
                  ? deleteSaleInvoice
                  : entityType === 'purchaseinvoice'
                  ? deletePurchaseInvoice
                  : entityType === 'salereturn'
                  ? deleteSaleReturnInvoice
                  : deletePurchaseReturnInvoice
            }
            dispatch={dispatch}
            type={entityType === 'saleinvoice' || entityType === 'purchaseinvoice' ? 'purchase' : 'receive'}
            userGlobalSettingsData={userGlobalSettingsData}
         />
      </>
   );
};

export default Ledger;
